import clsx from 'clsx'
import React, { FC } from 'react'

import { Button } from '@Components/Button'
import { Spinner } from '@Shared/Components/Spinner/Spinner'

import styles from './Link.module.scss'

export type LinkColor = 'primary' | 'dark' | 'white'

export interface LinkProps {
  className?: string
  color: LinkColor
  id?: string
  loading?: boolean
  newTab: boolean
  text: string
  url: string
}

export const Link: FC<LinkProps> = ({
  className,
  color,
  id,
  loading,
  newTab,
  text,
  url,
}) => (
  // TODO: Navigation event
  <a className={clsx(className, styles.anchor)} href={url} id={id} rel="noreferrer" target={newTab ? '_blank' : undefined}>
    <Button color={color}>
      {!loading && text}
      {loading && <Spinner style={{ width: '22px', height: '22px' }} />}
    </Button>
  </a>
)
